import React from "react";
import { View, StyleSheet } from "react-native";
import { GraduationCapIcon, ChartBarIcon, CheckCircleIcon, WarningCircleIcon, ClockIcon } from "@phosphor-icons/react";
import { spacing } from "../../../../styles/design-system";
import MetricCard from "./MetricCard";
import { GetCourseStudentInsightsQuery } from "../../../../graphql/generated/graphql";
import { formatPercentage } from "../../../../utils/analyticsUtils";

interface StudentProfileMetricsProps {
  studentInsights?: NonNullable<GetCourseStudentInsightsQuery["getCourseStudentInsights"]["data"]> | null;
}

const formatNullablePercentage = (value?: number | null): string => {
  if (value == null) {
    return "";
  }

  return formatPercentage(value);
};

const formatNullableRiskScore = (value?: number | null): string => {
  if (value == null) {
    return "";
  }

  return value.toFixed(1);
};

const StudentProfileMetrics = ({ studentInsights }: StudentProfileMetricsProps) => {
  const student = studentInsights?.student;

  return (
    <View style={styles.container}>
      <MetricCard
        icon={<GraduationCapIcon size={20} color="#475569" weight="regular" />}
        value={`${formatNullablePercentage(student?.aggregateGradePct)}`}
        label="Current Grade"
        context=""
      />

      <MetricCard
        icon={<ChartBarIcon size={20} color="#475569" weight="regular" />}
        value={formatNullablePercentage(student?.progressPct)}
        label="Overall Progress"
        context=""
      />

      <MetricCard
        icon={<CheckCircleIcon size={20} color="#475569" weight="regular" />}
        value={formatNullablePercentage(student?.assessmentTakenPct)}
        label="Assessments Taken"
        context=""
      />

      <MetricCard
        icon={<WarningCircleIcon size={20} color="#DC2626" weight="regular" />}
        value={formatNullableRiskScore(student?.riskScore)}
        label="Risk Score"
        context={student?.riskLevel ?? ""}
      />

      <MetricCard
        icon={<ClockIcon size={20} color="#475569" weight="regular" />}
        value={student?.sentiment ?? ""}
        label="Sentiment"
        context={student?.statusSummary ?? ""}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.lg,
    paddingBottom: spacing.sm,
  },
});

export default StudentProfileMetrics;
